import { render, staticRenderFns } from "./InputImage.vue?vue&type=template&id=77472574"
import script from "./InputImage.vue?vue&type=script&lang=js"
export * from "./InputImage.vue?vue&type=script&lang=js"
import style0 from "./InputImage.vue?vue&type=style&index=0&id=77472574&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports